"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeSubscriptions_de_de = void 0;
function backofficeSubscriptions_de_de() {
    return {
        "backoffice.subscription.creationtitle": "Subscription verwalten",
        "backoffice.subscription.creationtext": "Subscriptions definieren einen Preis für Projekterweiterungen. Sie können per Projekt gebucht und über Firmen abgerechnet werden!",
        "backoffice.subscription.selectfeatures": "Erweiterungen auswählen",
        "backoffice.subscriptions.description": "Mit Abonnements erweitern Sie Ihre Projekte um Funktionalitäten. Sie können beliebig viele Abonnements kombinieren, die angegebenen Werte werden aufaddiert und stehen Ihrem gesamten Projekt zur Verfügung",
        "backoffice.subscriptions.book": "Buchen",
        "backoffice.subscriptions.cancel": "Stornieren",
        "backoffice.subscriptions.cancelwarntitle": "Abonnement stornieren",
        "backoffice.subscriptions.cancelwarnmessage": "Alle bereits gezahlten Gebühren werden Ihnen auf der nächsten Rechnung gutgeschrieben und können für neue Buchungen verwendet werden.",
        "backoffice.subscriptions.cancelaftertrial": "Vor nächster Abrechnung stornieren",
        "backoffice.subscriptions.cancelnow": "Jetzt stornieren",
        "backoffice.subscriptions.continue": "Fortsetzen",
        "backoffice.subscriptions.trialperiod": "kostenlos ${days} Tage ausprobieren",
        "backoffice.subscriptions.setbookable": "auf buchbar setzen",
        "backoffice.subscriptions.setunbookable": "auf nicht buchbar setzen",
        "backoffice.subscriptions.bookedat": "gebucht am",
        "backoffice.subscriptions.cancelledat": "storniert für",
        "backoffice.subscriptions.trialendsat": "Testphase bis",
        "backoffice.subscriptions.errors.no_billing_email": "Ihre Firma hat keine Rechnungsemailadresse gespeichert. Bitte gehen Sie zu den Firmendetails und setzen Sie eine E-Mail Adresse für Rechnungen."
    };
}
exports.backofficeSubscriptions_de_de = backofficeSubscriptions_de_de;
